export function adding(button: HTMLButtonElement): void {
  const span: HTMLSpanElement = button.querySelector('span');
  const text = window.theme?.strings?.product?.addingToCart || 'Adding to cart';

  const el = span || button;

  button.disabled = true;
  el.innerText = text;
}

export function added(button: HTMLButtonElement): void {
  const span: HTMLSpanElement = button.querySelector('span');
  const text = window.theme?.strings?.product?.addedToCart || 'Added to cart';

  const el = span || button;

  button.disabled = true;
  el.innerText = text;

  setTimeout(() => {
    button.disabled = false;
    el.innerText = window.theme?.strings?.product?.addToCart || 'add to cart';
  }, 1000);
}
